function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor",
  d: "M1 1H13V10H10H8.63301H5.36228H4H1V1ZM4.9251 11H1C0.447716 11 0 10.5523 0 10V1C0 0.447715 0.447715 0 1 0H13C13.5523 0 14 0.447715 14 1V10C14 10.5523 13.5523 11 13 11H9.06799L7.35308 12.84C7.25937 12.9415 7.12788 12.9998 6.99018 13C6.85223 12.9998 6.72099 12.9415 6.62728 12.84L4.9251 11ZM7.701 11H6.28738L6.99156 11.7612L7.701 11Z"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 5,
  height: 1,
  rx: 0.5,
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 5,
  width: 8,
  height: 1,
  rx: 0.5,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 7,
  width: 8,
  height: 1,
  rx: 0.5,
  fill: "currentColor"
});

function SvgIconLogText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogText);
export default __webpack_public_path__ + "static/media/iconLogText.5744e72d.svg";
export { ForwardRef as ReactComponent };